import {
  RequestResponseSocketModel,
  RequestResponseViewModel,
  ResponseViewModel,
} from "~/pages/copilotMessage/types/copilot";

export const ConvertRequestSocketModelToViewModel = (
  requestResponse: RequestResponseSocketModel[],
): RequestResponseViewModel => {
  return {
    requests: requestResponse.map((x) => ({
      actionType: x.Request.ActionType,
      conversationId: x.Request.ConversationId,
      id: x.Request.Id,
      operationDate: x.Request.OperationDate,
      userId: x.Request.UserId,
    })),
    responses: requestResponse.flatMap((x) =>
      x.Responses.map(
        (y) =>
          ({
            actionType: y.ActionType,
            greetingMessages: y.GreetingMessages,
            observationMessages: y.ObservationMessages,
            checkMessages: y.CheckMessages || {},
            recommendationMessages: y.RecommendationMessages,
            data: y.Data,
            id: y.Id,
            requestId: x.Request.Id,
            operationDate: y.OperationDate,
            feedbackSummary: y.FeedbackSummary,
          }) as ResponseViewModel,
      ),
    ),
  };
};
